<div class="SLV2-main-wrapper">
    
    <div class="SLV2-body-section">

        <div class="SLV2-section-wrap SLV2-page-header-area">
            <div class="SLV2-page-header-lft">
                <button class="SLV2-header-text-button">
                    <img (click)="navigateToSelfLearnHomePage()" src="selflearnv2-ui/assets/img/self-learn-v2/banner-back-arrow.svg" />
                    <span>{{title}}</span>
                </button>
            </div>
        </div>


        <div class="SLV2-section-wrap">
            <div class="row SLV2-sm-gap">
                <div class="col-xl-3 col-lg-4 col-md-6" *ngFor="let item of cardList">
                    <app-video-card class="mobile-col-view" [videoData] ="item" (click)="navigatetoVideoPlayback(item)" [cardTitle]="item.title"></app-video-card>
                </div>
            </div>
        </div>


    </div>
</div>
